
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import PromptGrid from "@/components/prompts/PromptGrid";
import type { Prompt } from "@/services/promptService";

interface PromptsSectionProps {
  prompts: Prompt[];
  isOwnProfile: boolean;
  fullName: string;
}

const PromptsSection = ({ prompts, isOwnProfile, fullName }: PromptsSectionProps) => {
  return (
    <>
      <h2 className="text-xl font-semibold mb-4">
        {isOwnProfile ? "Your Prompts" : `${fullName}'s Prompts`}
      </h2>
      
      {prompts.length > 0 ? (
        <PromptGrid prompts={prompts} />
      ) : (
        <Card>
          <CardContent className="pt-6 text-center py-12">
            <p className="text-muted-foreground mb-4">
              {isOwnProfile ? 
                "You haven't created any prompts yet." : 
                "This user hasn't created any prompts yet."}
            </p>
            
            {isOwnProfile && (
              <Button asChild>
                <Link to="/create">Create Your First Prompt</Link>
              </Button>
            )}
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default PromptsSection;
